import { useFlags } from "launchdarkly-react-client-sdk";

import { env } from "~/env";
import { useAuthorization } from "~/hooks/useAuthorization";

/**
 * Whether the organisation's AI assistant settings page is offered: the chat
 * service is deployed to this stage, Compono has the assistant switched on
 * (`chatAiAssistant`), and the user is an owner or admin of any product.
 *
 * `canAccessAiChat` is that last test, exactly — the same rule the chat
 * service applies to the page's own requests. It no longer decides who may
 * use the assistant itself; the organisation's settings do.
 *
 * Deliberately not the organisation's own audience: an organisation that has
 * turned the assistant off for everyone must still be able to turn it on.
 */
export const useAssistantSettingsAvailable = (): boolean => {
  const { chatAiAssistant } = useFlags();
  const { permissions } = useAuthorization();
  return Boolean(
    env.CHAT_AI_URL && chatAiAssistant && permissions.canAccessAiChat,
  );
};
